import profiles from "./approvedScratchStyles.json";

export const APPROVED_SCRATCH_STYLE_IDS = ["S-9IT0", "S-EHIP", "S-HBLL", "S-I6MB", "S-K9A4"] as const;
export type ApprovedScratchStyleId = (typeof APPROVED_SCRATCH_STYLE_IDS)[number];

export function isApprovedScratchStyleId(value: string): value is ApprovedScratchStyleId {
  return (APPROVED_SCRATCH_STYLE_IDS as readonly string[]).includes(value);
}

export function approvedScratchStyleProfile(id: string) {
  if (!isApprovedScratchStyleId(id)) return null;
  return profiles[id];
}

export { profiles as approvedScratchStyles };
